export const SUR_FACTURE = 'Sur facture';
export const AU_COMPTANT = 'Au comptant';
